import * as types from "./application.actions"

const initialState = {
  fetching: {
    general: false,
    navigation: false,
  },
  epasrrUrl: "",
  user: {
    email: "",
    name: "",
    roles: [],
    id: "",
  },
  pageTitle: {
    title: "ePASRR",
    subTitle: null,
  },
  navigation: [],
  entities: {
    reviewers: {},
    facilities: {},
    notifications: {},
    MQDs: {},
  },
  breadCrumbs: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case types.FETCHING_DATA:
      return { ...state, fetching: { ...state.fetching, general: true } }

    case types.DATA_FETCHED:
      return { ...state, fetching: { ...state.fetching, general: false } }

    case types.EPASRR_URL_SET:
      return { ...state, epasrrUrl: action.payload }

    case types.USER_LOGGED_IN:
      return {
        ...state,
        user: { ...action.payload },
      }

    case types.USER_LOGGED_OUT:
      return { ...initialState }

    case types.PAGE_TITLE_SET:
      return { ...state, pageTitle: { ...action.payload } }

    case types.FETCHING_NAVIGATION:
      return { ...state, fetching: { ...state.fetching, navigation: true } }
    case types.NAVIGATION_RETRIEVED:
      return {
        ...state,
        navigation: normalizeNavigation(action.payload, state.epasrrUrl),
        fetching: { ...state.fetching, navigation: false },
      }

    case types.REVIEWERS_RETRIEVED:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.payload.entities,
        },
      }

    case types.MQDS_RETRIEVED:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.payload.entities,
        },
      }

    case types.FACILITIES_RETRIEVED:
      return {
        ...state,
        user: { ...state.user, facility: action.payload.userFacility },
        entities: {
          ...state.entities,
          ...action.payload.entities,
        },
      }

    case types.NOTIFICATION_RECEIVED:
      return {
        ...state,
        entities: {
          ...state.entities,
          notifications: {
            ...state.entities.notifications,
            ...action.payload.entities.notifications,
          },
        },
      }

    case types.NOTIFICATION_DISMISSED:
      return {
        ...state,
        entities: {
          ...state.entities,
          notifications: {
            ...removeKey(action.payload, state.entities.notifications),
          },
        },
      }

    case types.BREADCRUMBS_SET:
      return { ...state, breadCrumbs: action.payload }

    default:
      return state
  }
}

const removeKey = (key, object) =>
  Object.keys(object)
    .filter((x) => x !== key)
    .reduce((acc, k) => ({ ...acc, [k]: object[k] }), {})

export const normalizeNavigation = (items, epasrrUrl) => {
  const { origin } = document.location
  const isMailToLink = (item) => item.link.startsWith("mailto")
  const isRemoteLink = (item) =>
    item.caption !== "PASRR Review" &&
    item.caption !== "Interrater Reliability (IRR)" &&
    !isMailToLink(item)
  const removeRoles = ({ caption, link, children, hasLink }) => ({
    caption,
    link,
    children,
    hasLink,
  })
  const setChildren = (item) => ({
    ...item,
    children: normalizeNavigation(item.children, epasrrUrl),
  })
  const singularizeLink = (item) => ({ ...item, link: item.link[0] })
  const appendUrl = (item) =>
    isMailToLink(item)
      ? { ...item, remote: true }
      : isRemoteLink(item)
      ? { ...item, link: `${epasrrUrl}dist${item.link}`, remote: true }
      : { ...item, link: item.link.replace(origin, "") }

  return items
    .map(singularizeLink)
    .map(removeRoles)
    .map(appendUrl)
    .map(setChildren)
}



// WEBPACK FOOTER //
// ./src/application.reducer.js